import { Box } from "@chakra-ui/react";
import React from "react";
import useThemeColors from "../../hooks/useThemeColors";

interface Props {
  handleClick: () => void;
  children: React.ReactNode;
  minW?: string;
  reducedMotion?: boolean;
}

export default function SettingsCard({ handleClick, children, minW, reducedMotion = false }: Props) {
  const colors = useThemeColors();
  return (
    <Box
      bg={colors.background.muted}
      p={3}
      borderRadius={"md"}
      borderWidth={1}
      borderColor={colors.border.primary}
      minW={minW}
      transition={"300ms"}
      _hover={{
        backgroundColor: colors.schoolAccent.hover,
        cursor: "pointer",
        transform: reducedMotion ? "scale(1.008)" : "scale(1.02)",
      }}
      onClick={handleClick}
      position={"relative"}
    >
      {children}
    </Box>
  );
}
